import React, {Component} from 'react';

import ASNTable from '../../components/ASNTable/ASNTable';
import SearchASN from '../../components/SearchASN/SearchASN';
import {uploadASN, saveASN, deleteASN, searchASN} from '../../../actions/index';
import ModalASN from '../../components/ModalASN/ModalASN';
import NotificationLoading from '../../components/Notification-loading/Notification-loading';
import NotificationSuccess from '../../components/Notification-success/Notification-success';
import NotificationError from '../../components/Notification-error/Notification-error'
import UploadButton from '../../components/UploadButtonASN/UploadButtonASN';
import ModalUnsave from '../../components/Modal-unsave/Modal';
import ModalUnsavePage from '../../components/Modal-unsave-page/Modal';
import ModalErrorData from '../../components/ModalErrorData/ModalErrorData';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';

import './styles.css';

import * as FileSaver from 'file-saver';


class ASN extends Component {

    constructor(props) {
        super(props)  
        this.state = {
            data: [],
            show: false,
            showUnsavedModal: false,
            showUnsavedModalPage: false,
            showNotification: false,
            showNotificationSuccess: false,
            showNotificationEError: false,
            currentPage: 1,
            todosPerPage: 8,
            pageNumbers: [],
            currentPagination: 1,
            paginationLimit: 7,
            filteringItem: '',
            filteringVendor: '',
            noData: true,
            showErrorDataModal: false,
            errorUploadData: [],
            isSaved: false
        };   
      
    }

    openModal = e => {
        this.setState({
            show: !this.state.show
        });
    }

    openUnsavedModal = () => {
        this.setState({
            showUnsavedModal: !this.state.showUnsavedModal
        });
    }

    openUnsavedModalPage = () => {
        this.setState({
            showUnsavedModalPage: !this.state.showUnsavedModalPage
        });
    }

    openErrorDataModal = () => {
        this.setState({
            showErrorDataModal: !this.state.showErrorDataModal
        });
    }

    onDataModal = (hasData) => {
        this.openUnsavedModal();
    }

    openNotification = (show) => {
        this.setState({
            showNotification: show
        });
    }

    openNotificationSuccess = (show) => {
        this.setState({
            showNotificationSuccess: show
        });
    }

    openNotificationError = (show) => {
        this.setState({
            showNotificatioError: show
        });
    } 

    createExcelFile = async (csvData) => {

        const XLSX = await import("xlsx");

        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';

        const ws = XLSX.utils.json_to_sheet(csvData);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], {type: fileType});
        FileSaver.saveAs(data, 'ASN-file' + fileExtension);
    }

    onExportToExcel = (data) => {
        let csvData;
        if(this.state.data.length > 0) {
            csvData = JSON.parse(JSON.stringify(this.state.data));
            const checkedArray = JSON.parse(JSON.stringify(this.state.data.filter(obj => obj.checked == true)));
            csvData.map(data => {
                data.vendor = data.vendorId;
                delete data.vendorId;
                delete data.checked;
                delete data.displayDate;   
                delete data.index;   
                delete data.qtyChanged;
                delete data.uploadedData;
            });
            if(checkedArray.length > 0) {
                checkedArray.map(data => {
                    data.vendor = data.vendorId;
                    delete data.vendorId;
                    delete data.checked;
                    delete data.displayDate;   
                    delete data.index;   
                    delete data.qtyChanged;
                    delete data.uploadedData;
                });
                this.createExcelFile(checkedArray);
            } else {
                this.createExcelFile(csvData);
            }
        } else {
            this.openNotification(true);
            const data = {
                dcId: null,
                itemId: null,
                purchaseOrderNumber: null,
                vendorId: null
            }
            searchASN(data).then(res => {
                this.openNotification(false);
                res.data.data.map(data =>{
                    data.vendor = data.vendorId;
                    delete data.vendorId;
                });
                this.createExcelFile(res.data.data);
            }).catch(err => {
                this.openNotification(false);
                this.displayErrorMessage(err);
            });
        }
    }

    displayErrorMessage = (err) => {
        let message;
        if(err.response.status === 503) {
            message = err.response.data.errors[0].title;
        } else if(err.response.status === 401) {
            message = 'The authentication token expired, please re-login and try again.';
        } else {
            message = 'An error has occurred, verify that the data is correct and without duplicates and tried again.';
        }
        this.setState({messageError: message}, function() {
            this.openNotificationError(true); 
            setTimeout(() => { this.openNotificationError(false) }, 15000);
        });
    }

    formatResponseFunction = (res, type) => {
        if(res.data.success == true) {
            this.openNotificationSuccess(true);
            setTimeout(() => { this.openNotificationSuccess(false) }, 2000);
            res.data.data.map((obj, i) => {
                let date = obj.lastModified.split(" ")[0]
                obj.displayDate = date;
                obj.checked = false;
                obj.index = i;
                obj.qtyChanged = false;
                if(type == 'excel') {
                    obj.uploadedData = true;
                } else {
                    obj.uploadedData = false;
                }
            });
            let pages = [];
            for (let i = 1; i <= Math.ceil( res.data.data.length / this.state.todosPerPage); i++) {
                pages.push(i);
            }
            if(type != 'save') {
                this.setState({data: res.data.data, pageNumbers: pages, noData: false, isSaved: false});
            } else {
                this.setState({data: res.data.data, pageNumbers: pages, noData: false});
            }
        } else {
            const data = res.data.dataError;
            this.setState({errorUploadData: data}, function() {
                this.openErrorDataModal();
            })
            let message = "Error in some data fields, please check the logs.";
            this.setState({messageError: message}, function() {
                this.openNotificationError(true); 
                setTimeout(() => { this.openNotificationError(false) }, 15000);
            });
        } 
    }

    onGetExcelData = (excelData) => {
        const data = {
            data: excelData
        }
        this.uploadASNData(data);
    }

    uploadASNData = (data) => {
        uploadASN(data).then(res => {
            this.openNotification(false);
            this.formatResponseFunction(res, 'excel');
        }).catch(err => {
            this.openNotification(false);
            this.displayErrorMessage(err);
        });
    }

    addSingleASN = (data) => {
        const asn = {
            data: [data]
        };
        this.uploadASNData(asn);
    }

    saveASN = () => {
        if(this.state.data.length > 0) {
            this.openNotification(true);
            const userId = sessionStorage.getItem("uId");
            const data = {
                audit: {userId: userId},
                data: this.state.data
            };
            saveASN(data).then(res => {
                this.openNotification(false);
                this.formatResponseFunction(res, 'save');
                this.setState({isSaved: true});
                setTimeout(() => { this.openNotificationSuccess(false) }, 2000);
            }).catch(err => {
                this.openNotification(false);
                this.displayErrorMessage(err);
           })
        }   
    }

    deleteASN = () => {
        this.openNotification(true);
        const deleteArray = this.state.data.filter(obj => obj.checked == true);
        const data = {
            data: deleteArray
        };
        deleteASN(data).then(res => {
                this.openNotification(false);
                this.openNotificationSuccess(true);
                setTimeout(() => { this.openNotificationSuccess(false) }, 2000);
                let idsToDelete = deleteArray.map(data => data.index);
                let result = this.state.data.filter(data => idsToDelete.indexOf(data.index) === -1);
                result.map((obj, i) => {
                    obj.index = i;
                });
                let pages = [];
                for (let i = 1; i <= Math.ceil( result.length / this.state.todosPerPage); i++) {
                    pages.push(i);
                }   
                this.setState({data: result,  pageNumbers: pages,});
        }).catch(err => {
            this.openNotification(false);
            this.displayErrorMessage(err);
        });
    }

    multiSearchASN = (data) => {
        this.openNotification(true);
        if(data.vendorId.length == 0) data.vendorId = null;
        if(data.itemId.length == 0) data.itemId = null;
        if(data.dcId.length == 0) data.dcId = null;
        if(data.purchaseOrderNumber.length == 0) data.purchaseOrderNumber = null;
        delete data.filterByItem;
        delete data.filterByVendor;
        searchASN(data).then(res => {
            this.openNotification(false);
            this.formatResponseFunction(res, 'search');
        }).catch(err => {
            this.openNotification(false);
            this.displayErrorMessage(err);
        });
    }

    searchData = (data) => {
        if ( (data.vendorId.length > 0 && data.dcId.length > 0 && data.itemId.length > 0 &&  data.purchaseOrderNumber.length == 0) || 
        (data.dcId.length > 0 && data.itemId.length > 0 && data.purchaseOrderNumber.length == 0 && data.vendorId.length == 0) || 
        (data.vendorId.length > 0 && data.itemId.length > 0 && data.purchaseOrderNumber.length == 0 && data.dcId.length == 0) || 
        (data.vendorId.length > 0 && data.dcId.length > 0 && data.purchaseOrderNumber.length == 0 && data.itemId.length == 0) || 
        (data.vendorId.length > 0 && data.purchaseOrderNumber.length == 0 && data.itemId.length == 0 && data.dcId.length == 0) || 
        (data.purchaseOrderNumber.length > 0 && data.itemId.length > 0 && data.dcId.length == 0 && data.vendorId.length == 0) || 
        (data.purchaseOrderNumber.length > 0 && data.dcId.length == 0 && data.vendorId.length == 0 && data.itemId.length == 0) ) {
            const objASN = JSON.parse(JSON.stringify(data));
            this.multiSearchASN(objASN);
        } else {
           this.setState({messageError: "Please enter a valid search."}, function() {
            this.openNotificationError(true); 
            setTimeout(() => { this.openNotificationError(false) }, 5000);
        });
        }
    }

   
    qtyValueChange = (value) => {
        value.map(obj => {
            this.state.data[obj.index] = obj;
        });
        this.setState({data: this.state.data});
    }

    filterByItem = (item) => {
        this.setState({filteringItem: item});
    }

    filterByVendor = (vendor) => {
        this.setState({filteringVendor: vendor})
    }

    checkboxChange = (value) => {
        const index = value.index;
        if(value.checked == false) {
            this.state.data[index].checked = true;
        } else {
            this.state.data[index].checked = false;
        }
        this.setState({data: this.state.data});
    }

    checkboxAll = (isCheckedAll) => {
        if(isCheckedAll == true) {
            this.state.data.map(obj => {
                obj.checked = true;
            });
        } else {
            this.state.data.map(obj => {
                obj.checked = false;
            });
        }
        this.setState({data: this.state.data});
    }

    handleClick = (number) => {
        const pageNumber = number;
        this.setState({
          currentPage: pageNumber
        });
    }

    handleClickPagination = (number) => {
        if(this.state.pageNumbers.length > 0) {
            if(typeof(number) === 'number') {
                const pageNumber = this.state.currentPagination + number;
                const limitPagination = Math.ceil(this.state.pageNumbers.length / this.state.paginationLimit);
                if(pageNumber > 0 && pageNumber <= limitPagination) {
                    this.setState({
                        currentPagination: pageNumber
                    });
                }
            } else {
                if(number === 'first') {
                    this.setState({
                        currentPagination: 1
                    });
                } else {
                    const limitPagination = Math.ceil(this.state.pageNumbers.length / this.state.paginationLimit);
                    this.setState({
                        currentPagination: limitPagination
                    });
    
                }
            }   
        }
    }

    errorHeaderExcel = () => {
        const message = `Excel file must meet the following criteria: headers must be in row #1. Headers name should match the required and are case sensitive: 
        purchaseOrderNumber, suffix, itemId, qty`;
        this.openNotification(false);
        this.setState({messageError: message}, function() {
            this.openNotificationError(true); 
            setTimeout(() => { this.openNotificationError(false) }, 15000);
        });
    }

    close = () => {
        if(this.state.data.length > 0 && this.state.isSaved == false) {
            this.openUnsavedModalPage();
        } else {
            this.discardChangesPage(true);   
        }  
    }

    discardChanges = (discard) => {
        this.openUnsavedModal();
        this.openModal();
    }

    discardChangesPage = (discard) => {
        this.props.history.push("/");  
    }

    saveModalPage = (save) => {
        this.openUnsavedModalPage();
        this.saveASN();
    }

    createTemplateExcel = async () => {

        const XLSX = await import("xlsx");
        
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';
        const dataTemplate = [{
            "purchaseOrderNumber": "",
            "suffix": "",
            "itemId": "",
            "qty": ""
        }]


        const ws = XLSX.utils.json_to_sheet(dataTemplate);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], {type: fileType});
        FileSaver.saveAs(data, 'Template-File-ASN' + fileExtension);
    }
    

    render() {

        const { currentPage, todosPerPage, noData } = this.state;

        // Logic for displaying current todos
        const indexOfLastTodo = currentPage * todosPerPage;
        const indexOfFirstTodo = indexOfLastTodo - todosPerPage;
        let currentTodos = this.state.data.slice(indexOfFirstTodo, indexOfLastTodo);

        if(this.state.filteringItem.length > 0 || this.state.filteringVendor.length > 0) {
            currentTodos = this.state.data.filter(obj => {
               if(String(obj.itemNumber).startsWith(this.state.filteringItem) && String(obj.vendorId).startsWith(this.state.filteringVendor)) {
                   return true;
               }
            });
        }


        //Pagination logic

        const { currentPagination, paginationLimit } = this.state;

        const indexOfLastPagination = currentPagination * paginationLimit;
        const indexOfFirstPagination = indexOfLastPagination - paginationLimit;
        const currentPaginationList = this.state.pageNumbers.slice(indexOfFirstPagination, indexOfLastPagination);  

        return (
            <div className="container-fluid">
                <h3 className="page-title">Override Advance Shipping Notice</h3>
                <SearchASN data={this.searchData} filterByItem={this.filterByItem} filterByVendor={this.filterByVendor} isData={this.state.noData}/>
                <ModalASN onClose={this.openModal} show={this.state.show} onData={this.onDataModal} openNotification={this.openNotification} dataASN={this.addSingleASN}/>
                <ASNTable data={currentTodos} qtyValue={this.qtyValueChange} checkboxChange={this.checkboxChange} selectAllCheckbox={this.checkboxAll}/> 
                <Pagination aria-label="Table navigation" className="pagination" style={{display: (noData? 'none': 'flex')}}>
                    <PaginationItem>
                        <PaginationLink first  onClick={e => {this.handleClickPagination('first')}}/>
                    </PaginationItem>
                    <PaginationItem>
                        <PaginationLink previous onClick={e => {this.handleClickPagination(-1)}}/>
                    </PaginationItem>
                    {this.state.data.length > 0 ? currentPaginationList.map((data, key) => {
                        return (
                            <PaginationItem key={key}>
                                <PaginationLink onClick={e => this.handleClick(data)}>
                                    {data}
                                </PaginationLink>
                            </PaginationItem>
                        )
                    }): <div></div>
                    }
                    <PaginationItem>
                        <PaginationLink  next onClick={e => {this.handleClickPagination(1)}}/>
                    </PaginationItem>
                    <PaginationItem>
                        <PaginationLink last onClick={e => {this.handleClickPagination('last')}}/>
                    </PaginationItem>
                </Pagination>  
                <div className="actionss-container">
                    <button type="button" className="btn btn-warning actions-button btn-sm" onClick={this.close}>Close</button>
                    <button type="button" className="btn btn-warning actions-button  btn-sm" onClick={this.createTemplateExcel}>Create Template</button>
                    <button type="button" className="btn btn-warning actions-button  btn-sm" onClick={this.onExportToExcel}>Export</button>
                    <button type="button" className="btn btn-warning actions-button vendor btn-sm" onClick={this.openModal}>Add</button>
                    <UploadButton  onGetExcelData={this.onGetExcelData} openNotification={this.openNotification} errorHeader={this.errorHeaderExcel}/>
                    <button type="button" className="btn btn-warning actions-button  btn-sm" onClick={this.deleteASN}>Delete</button>
                    <button type="button" className="btn btn-warning actions-button btn-sm" onClick={this.saveASN} disabled={this.state.data.length == 0}>Save</button>
                </div>
                <NotificationLoading show={this.state.showNotification} onClose={this.openNotification}/>
                <NotificationError show={this.state.showNotificatioError} onClose={this.openNotificationError} message={this.state.messageError}/>
                <NotificationSuccess show={this.state.showNotificationSuccess} onClose={this.openNotificationSuccess}/>
                <ModalUnsave showw={this.state.showUnsavedModal} onClose={this.openUnsavedModal} onDiscard={this.discardChanges}/>
                <ModalUnsavePage show={this.state.showUnsavedModalPage} onClose={this.openUnsavedModalPage} onDiscard={this.discardChangesPage} onSave={this.saveModalPage}/>
                <ModalErrorData show={this.state.showErrorDataModal} onClose={this.openErrorDataModal} data={this.state.errorUploadData}/>
            </div>
        );
    }

}

export default ASN;